<template>
    <div style="height:80%;display: flex; justify-content: center; align-items: center">
        <div style="width: 100%">
            <!-- <div ref="plateForm" class="weui-form-area">
                <div class="weui-cells weui-cells_form">
                    <plate-input @onChange="getPlateNumber"></plate-input>
                </div>

                <div class="weui-btn-area">
                    <button class="weui-btn weui-btn_warn" @click="checkParkHour">查询停车时长</button>

                </div>

            </div> -->
            <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">车牌号</label></div>
                <div class="weui-cell__bd">
                    <span> {{ plateno || "无" }} </span>
                </div>
            </div>
            <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">停车开始时间</label></div>
                <div class="weui-cell__bd">
                    <span> {{ inTime || "无" }} </span>
                </div>
            </div>
            <!-- <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">停车结束时间</label></div>
                <div class="weui-cell__bd">
                    <span> {{ updateTime || "无" }} </span>
                </div>
            </div> -->
            <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">停车时长</label></div>
                <div class="weui-cell__bd">
                    <span> {{ parkHours || "无" }} </span>
                </div>
            </div>
            <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">总金额</label></div>
                <div class="weui-cell__bd">
                    <span> {{ unpaidMoney || 0 }} </span>
                </div>
            </div>



            <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">优惠金额</label></div>
                <div class="weui-cell__bd">
                    <span> {{ DeductionMoney || 0 }} </span>
                </div>
            </div>

            <!-- <div class="weui-cell weui-cell_active">
                <div class="weui-cell__hd"><label class="weui-label">应付金额</label></div>
                <div class="weui-cell__bd">
                    <span> {{ money <= 0 ? "0" : money || unpaidMoney }} </span>
                </div>
            </div> -->




            <article class="weui-article">
                <section>
                    <div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd" style="color: #0d0d0d"><label class="weui-label">代付时长</label></div>

                        <div class="weui-cell__bd" @click="chooseRationType">
                            {{ checkedCoupon }}
                        </div>
                    </div>
                </section>
            </article>






            <button v-if="Disable" class="weui-btn weui-btn_default" @click="toPay">支付</button>
            <button v-else class="weui-btn weui-btn_default">已支付</button>
        </div>

    </div>
</template>

<script>
import { prepaidSettlement } from "../../api/coupon/pay";
// import { getRecordByPlateNo } from '../../../api/coupon/platePay'
import { getRecordByPlateNo, getPrecomputation } from '../../api/coupon/platePay'
// import plateInput from '../components/plateInput'
import plateInput from './components/plateInput'
import { mapGetters } from 'vuex'

export default {
    name: "PaymentAmount",
    data() {
        return {
            Disable: true,
            money: undefined,//应付金额
            unpaidMoney: undefined,//总金额
            DeductionMoney: undefined,//优惠金额
            parkinglotId: undefined,//停车场ID
            couponTaskId: undefined,//优惠券ID
            plateForm: {
                bindMethod: 2,
            },
            recId: "",

            plateno: undefined,//车牌号
            parkHours: undefined,//停车时长
            inTime: undefined,//停车开始时间
            updateTime: undefined,//停车结束时间
            checkedCouponId: undefined,
            checkedCoupon: undefined,
            checkedCouponOptions: [

                {
                    value: '0',
                    label: '全部'
                },
                {
                    value: '1',
                    label: '一小时'
                },
                {
                    value: '3',
                    label: '二小时'
                },
                {
                    value: '3',
                    label: '三小时'
                },
                {
                    value: '4',
                    label: '四小时'
                },
                {
                    value: '5',
                    label: '五小时'
                },
                {
                    value: '6',
                    label: '六小时'
                },
                {
                    value: '7',
                    label: '七小时'
                },
                {
                    value: '8',
                    label: '八小时'
                },
                {
                    value: '9',
                    label: '九小时'
                },
                {
                    value: '10',
                    label: '十小时'
                },
                {
                    value: '11',
                    label: '十一小时'
                },
                {
                    value: '12',
                    label: '十二小时'
                },
                {
                    value: '13',
                    label: '十三小时'
                },
                {
                    value: '14',
                    label: '十四小时'
                },
                {
                    value: '15',
                    label: '十五小时'
                },
                {
                    value: '16',
                    label: '十六小时'
                },
                {
                    value: '17',
                    label: '十七小时'
                },
                {
                    value: '18',
                    label: '十八小时'
                },
                {
                    value: '19',
                    label: '十九小时'
                },
                {
                    value: '20',
                    label: '二十小时'
                },
                {
                    value: '21',
                    label: '二十一小时'
                },
                {
                    value: '22',
                    label: '二十二小时'
                },
                {
                    value: '23',
                    label: '二十三小时'
                },
                {
                    value: '24',
                    label: '二十四小时'
                },
            ],
        }
    },
    components: {
        plateInput
    },
    computed: {
        ...mapGetters(['userPhone',])
    },
    created() {

        this.checkedCouponId = this.checkedCouponOptions[0].value
        this.checkedCoupon = this.checkedCouponOptions[0].label

        if (this.$route.query.parkinglotId) {
            this.parkinglotId = this.$route.query.parkinglotId;
        }
        if (this.$route.query.couponTaskId) {
            this.couponTaskId = this.$route.query.couponTaskId;
        }
        if (this.$route.query.couponType) {
            this.couponType = this.$route.query.couponType;
        }
        if (this.$route.query.recId) {
            this.recId = this.$route.query.recId;
        }
        if (this.$route.query.unpaidMoney) {
            this.unpaidMoney = this.$route.query.unpaidMoney;
        }
        if (this.$route.query.plateno) {
            this.plateno = this.$route.query.plateno;
        }
        if (this.$route.query.parkHours) {
            this.parkHours = this.$route.query.parkHours;
        }
        if (this.$route.query.inTime) {
            this.inTime = this.$route.query.inTime;
        }
        if (this.$route.query.updateTime) {
            this.updateTime = this.$route.query.updateTime;
        }


    },
    methods: {
        getPrecomputationMoney() {
            let params = {
                couponTaskId: this.couponTaskId,

                recId: this.recId,
                parkinglotId: this.parkinglotId,
                 businessphone: this.userPhone,
                //businessphone: '18862252919',
                hoursNum: this.checkedCouponId,
                money: this.unpaidMoney
            }
            getPrecomputation(params).then(res => {
                console.log(res, '与抵扣金额');
                this.DeductionMoney = res.data
                this.money = this.unpaidMoney - this.DeductionMoney

            })
        },
        getPlateNumber(data) {
            console.log('传值', data);
            this.$set(this.plateForm, 'platenumber', data);
        },

        checkParkHour() {
            if (this.plateForm.platenumber && this.plateForm.platenumber.length >= 7) {
                getRecordByPlateNo({ plateno: this.plateForm.platenumber, parkinglotId: this.parkinglotId }).then(res => {
                    console.log(res, '停车时长');
                    if (res.code === 200) {
                        this.recId = res.data.id
                        this.unpaidMoney = res.data.unpaidMoney
                        console.log(this.durationId, 'durationId');
                        this.$weui.alert("该车停车时长: " + res.data.parkHours);
                        this.$router.push({ name: 'PaymentAmount', params: { couponTaskId: id, parkinglotId: parkinglotId, couponType: couponType } });

                    }
                });
            } else {
                this.$weui.alert('车牌号长度有误！')
            }
        },
        chooseRationType() {
            this.$weui.picker(this.checkedCouponOptions, {
                onChange: result => {
                    this.checkedCoupon = result[0].label;
                    this.checkedCouponId = result[0].value;
                    // this.getPrecomputationMoney()

                },
                onConfirm: result => {
                    this.checkedCoupon = result[0].label;
                    this.checkedCouponId = result[0].value;
                    if (this.checkedCouponId != 0) {
                        this.getPrecomputationMoney()
                    }

                },
                // onClose: () => {
                //     this.userChooseCoupon()
                // },
                title: '可选优惠券'
            });
        },
        toPay() {

            let payForm = {}
            if (this.checkedCouponId == 0) {
                payForm = {
                    couponMoney: this.unpaidMoney,
                    money: this.unpaidMoney,
                    businessphone: this.userPhone,
                    //businessphone:'18862252919',
                    goodsType: 7,
                    parkinglotId: this.parkinglotId,
                    payType: 13,
                    recId: this.recId,
                    hoursNum: this.checkedCouponId,
                    couponTaskId: this.couponTaskId,
                    openId: localStorage.getItem('userOpenId')
                };
            } else {
                payForm = {
                    couponMoney: this.DeductionMoney,
                    money: this.unpaidMoney,
                    businessphone: this.userPhone,
                    //businessphone: '18862252919',
                    goodsType: 7,
                    parkinglotId: this.parkinglotId,
                    payType: 13,
                    recId: this.recId,
                    hoursNum: this.checkedCouponId,
                    couponTaskId: this.couponTaskId,
                    openId: localStorage.getItem('userOpenId')
                };
            }

            if (this.couponType == 10 && !this.recId) {
                this.$weui.alert("代付必须查询停车时长");
            } else {

                console.log(payForm.couponMoney, 'this.couponMoney');

                if (payForm.couponMoney == 0 || !payForm.couponMoney) {
                    this.$weui.alert("优惠金额为0,无法支付");
                } else {
                    prepaidSettlement(payForm).then(res => {
                        if (res.code == 200) {
                            this.Disable = false
                            this.$weui.alert("支付成功");
                        }

                    })
                }

            }

        },
    }
}
</script>

<style scoped>
.weui-article {
    padding: 0 !important;
}
</style>
